import { input, inject, computed, Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { SVG_SPRITE_URL } from './svg-icon-tokens';

@Component({
  selector: 'svg[appIcon]',
  template: '<svg:use [attr.href]="href()"></svg:use>',
  styleUrl: './svg-icon.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-svg-icon',
  },
})
export class SvgIcon {
  private readonly spriteUrl = inject(SVG_SPRITE_URL, { optional: true });

  public readonly appIcon = input.required<string>();

  protected readonly href = computed(() => {
    const icon = this.appIcon();

    return this.spriteUrl ? `${this.spriteUrl}#${icon}` : `#${icon}`;
  });
}
